import React, { memo, useEffect, useRef } from "react"

const BookingWidget = () => {
  const widgetContainerRef = useRef(null)
  useEffect(() => {
    const script = document.createElement("script")
    script.async = true
    script.src = "//widget.simplybook.me/v2/widget/widget.js"
    script.onload = () => {
      new SimplybookWidget({
        widget_type: "iframe",
        url: "https://purebaby.simplybook.me",
        theme: "minimal",
        theme_settings: {
          timeline_show_end_time: "1",
          timeline_modern_display: "as_slots",
          hide_company_label: "0",
          timeline_hide_unavailable: "1",
          hide_past_days: "0",
          sb_base_color: "black",
          btn_color_1: "#cae0e8,#cae0e8,#cae0e8",
          link_color: "#153b60",
          display_item_mode: "block",
          body_bg_color: "#ffffff",
          sb_review_image: "",
          dark_font_color: "#2b212b",
          light_font_color: "#2b212b",
          sb_company_label_color: "#153b60",
          hide_img_mode: "0",
          sb_busy: "#aaa6aa",
          sb_available: "#2b212b",
        },
        timeline: "modern",
        datepicker: "top_calendar",
        is_rtl: false,
        app_config: { clear_session: 0, allow_switch_to_ada: 0, predefined: [] },
        container_id: "sbw_51uam9",
      })
    }
    document.head.appendChild(script)
    return () => {
      document.head.removeChild(script)
    }
  }, [])
  return <div id="sbw_51uam9" ref={widgetContainerRef}></div>
}

export default memo(BookingWidget)
